import "src/decidim/decidim_awesome/proposals/images";
import "src/decidim/decidim_awesome/forms/autosave";
import "src/decidim/decidim_awesome/voting/voting_cards";
import "src/decidim/decidim_awesome/amendments/show_modal_on_limits";
